const upComingParams = {
    getUpcomingParams : "/races?page=1&size=10&is_past_race=false",
}

export default upComingParams